import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to load other pipes dynamically
 */
@Pipe({ name: 'dynamic' })
export class DynamicPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value Any
   * @param pipe PipeTransform
   * @param config Config of pipe
   */
  transform(value: any, pipe: PipeTransform | any, config: []): any {
    if (!pipe) {
      return value;
    }

    if (typeof pipe === 'function') {
      return pipe(value);
    }

    if (config) {
      return pipe.transform(value, ...config);
    }

    return pipe.transform(value);
  }
}
